import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { BalanceType } from '@pt/models';
import { UiStore } from '@pt/services';
import { RootState } from '@pt/store';
import { Observable } from 'rxjs';
import { SpinnerService } from '@hglobal/common';
import SwiperCore, { Pagination, SwiperOptions } from 'swiper';
import { AccrualUserFormDialog, TeamBonusesActions, TransactionsDialog } from '@pt/components';

import { BalanceSelectors, BalanceViewModel } from './store';

SwiperCore.use([Pagination]);

@Component({
  standalone: false,
  selector: 'pu-balances',
  templateUrl: './balances.component.html',
  styleUrls: ['./balances.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BalancesComponent {
  readonly uiStore = inject(UiStore);

  isCard = input<boolean>(true);

  vm$: Observable<BalanceViewModel>
    = this._store.select(BalanceSelectors.selectViewModel);

  sliderConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 4,
    grabCursor: true,
    navigation: {
      prevEl: '.pu-balances__slider-controls_prev',
      nextEl: '.pu-balances__slider-controls_next',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  constructor(
    private _accrualUserFormDialog: AccrualUserFormDialog,
    private _store: Store<RootState>,
    private _spinner: SpinnerService,
    private _transactionsDialog: TransactionsDialog,
  ) {
    this._spinner.observe(this._store.select(BalanceSelectors.selectIsLoading).pipe(
      takeUntilDestroyed(),
    ));
  }

  share(): void {
    this._accrualUserFormDialog.open('site');
  }

  openTeamBonuses(): void {
    this._store.dispatch(TeamBonusesActions.openTeamBonusesDialog({
      openedFromPersonalInfo: false,
    }));
  }

  openHistory(type: BalanceType): void {
    this._transactionsDialog
      .open(<any>{}, false, type === 'functional')
      .afterClosed()
      .subscribe();
  }

  getCoinsCategoryFaqPath(vm: BalanceViewModel): string {
    return vm?.coinsCategory?.name
      ? `/${vm?.coinsCategory?.slug}`
      : '';
  }
}
